import React from "react";
import { Container } from "react-bootstrap";
import BreadCrumb from "../src/components/Shared/BreadCrumb";
import server from "../src/api/server";
import { useIntl } from "react-intl";
import { NextSeo } from "next-seo";
const TermsPge = ({ termsData, error , metaDataSections }) => {
  error && console.log(JSON.parse(error));
  const { locale, formatMessage } = useIntl();
  // console.log(termsData[0]?.description[locale], "privacy");
  const termsMeta = metaDataSections?.find((item) => item?.slug === "terms");
  return (
    <>
     <NextSeo
        title={termsMeta?.name[locale]}
        description={termsMeta?.description[locale]}
        additionalMetaTags={[
          {
            name: "keywords",
            content: "",
          },
          {
            name: "description",
            content: "",
          },
        ]}
      />
      <div className="about-page">
        <BreadCrumb
          title={formatMessage({ id: "Terms and Conditions Policy" })}
          pageTitle={formatMessage({ id: "Terms and Conditions Policy" })}
        />
        <div className="about-page-body">
          <Container>
            <div
            className="terms-sec"
              style={{
                marginBlock: "60px",
                fontSize:'20px'
              }}
              dangerouslySetInnerHTML={{
                __html: termsData[0]?.description[locale],
              }}
            ></div>
          </Container>
        </div>
      </div>
    </>
  );
};

export const getStaticProps = async (ctx) => {
  try {
    const termsResponse = await server.get("/pages/termsandconditions");
    const metaDataResponse = await server.get("/pages/metaData");
    return {
      revalidate: 1,
      props: {
        metaDataSections: metaDataResponse?.data?.data?.page?.sections,
        termsData: termsResponse.data.data.page.sections,
      },
    };
  } catch (error) {
    return {
      revalidate: 1,
      props: {
        error: JSON.stringify(error),
      },
    };
  }
};

export default TermsPge;
